import { render, staticRenderFns } from "./w-menu-action.vue?vue&type=template&id=d786c4b6&lang=pug&"
import script from "./w-menu-action.vue?vue&type=script&lang=js&"
export * from "./w-menu-action.vue?vue&type=script&lang=js&"
import style0 from "./w-menu-action.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d786c4b6')) {
      api.createRecord('d786c4b6', component.options)
    } else {
      api.reload('d786c4b6', component.options)
    }
    module.hot.accept("./w-menu-action.vue?vue&type=template&id=d786c4b6&lang=pug&", function () {
      api.rerender('d786c4b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-menu-action.vue"
export default component.exports